import { useEffect, useState } from "react";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import "./SystemSettings.css";

const defaultSettings = {
  workspaceName: "Strides AAR",
  defaultUserRole: "viewer",
  allowViewerAarCreation: true,
};

function SystemSettings() {
  const [settings, setSettings] = useState(defaultSettings);
  const [isLoading, setIsLoading] = useState(true);
  const [isSaving, setIsSaving] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    getDoc(doc(db, "settings", "system"))
      .then((snapshot) => {
        if (snapshot.exists()) {
          setSettings({ ...defaultSettings, ...snapshot.data() });
        }
      })
      .catch(() => setError("Settings could not be loaded."))
      .finally(() => setIsLoading(false));
  }, []);

  const handleChange = (event) => {
    const { name, type, value, checked } = event.target;
    setSettings((current) => ({
      ...current,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsSaving(true);
    setMessage("");
    setError("");

    try {
      await setDoc(doc(db, "settings", "system"), settings, { merge: true });
      setMessage("System settings saved.");
    } catch {
      setError("Settings could not be saved. Confirm the updated Firestore rules are published.");
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <main className="system-settings-page">
      <header className="system-settings-header">
        <span>ADMINISTRATION</span>
        <h1>System Settings</h1>
        <p>Control workspace defaults for the AAR team.</p>
      </header>

      <form className="system-settings-panel" onSubmit={handleSubmit}>
        {isLoading ? (
          <p className="settings-state">Loading settings...</p>
        ) : (
          <>
            <label htmlFor="workspace-name">Workspace name</label>
            <input
              id="workspace-name"
              name="workspaceName"
              value={settings.workspaceName}
              onChange={handleChange}
              required
            />

            <label htmlFor="default-user-role">Default new-user role</label>
            <select
              id="default-user-role"
              name="defaultUserRole"
              value={settings.defaultUserRole}
              onChange={handleChange}
            >
              <option value="viewer">Viewer</option>
              <option value="reviewer">Reviewer</option>
              <option value="admin">Administrator</option>
            </select>

            <label className="settings-checkbox">
              <input
                type="checkbox"
                name="allowViewerAarCreation"
                checked={settings.allowViewerAarCreation}
                onChange={handleChange}
              />
              Allow viewers to create AAR submissions
            </label>

            <button type="submit" disabled={isSaving}>
              {isSaving ? "Saving..." : "Save Settings"}
            </button>
          </>
        )}
      </form>

      {message && <p className="settings-message settings-success" role="status">{message}</p>}
      {error && <p className="settings-message settings-error" role="alert">{error}</p>}
    </main>
  );
}

export default SystemSettings;
